import { IconButton } from '@bnnvara/buttons';
import { VolumeFull } from '@bnnvara/icons/src/components/UserInterfaceIcons/VolumeFull';
import { VolumeMuted } from '@bnnvara/icons/src/components/UserInterfaceIcons/VolumeMuted';
import PropTypes from 'prop-types';
import React from 'react';

export function SoundToggle({ isMuted, toggle }) {
  return (
    <IconButton
      onClick={toggle}
      title={`Zet notificatie geluid ${isMuted ? 'aan' : 'uit'}`}
    >
      {isMuted && <VolumeMuted />}
      {!isMuted && <VolumeFull />}
    </IconButton>
  );
}

SoundToggle.propTypes = {
  isMuted: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
